import { css } from '@emotion/react';
import type { ReactElement } from 'react';
import { memo } from 'react';

import { styled } from '../../styled';
import { Theme } from '../../theme/interface/detailed';
import { useTheme } from '../../theme/useTheme';

type IconInterface = {
	className: string;
	filled: boolean;
	onClick: VoidFunction;
	onMouseEnter: VoidFunction;
	onMouseLeave: VoidFunction;
};

const styles = css`
	cursor: pointer;
`;

const Component = ({ className, filled, onClick, onMouseEnter, onMouseLeave }: IconInterface): ReactElement => {
	const theme = useTheme();
	return (
		<div className={className} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
			<svg
				width={theme.ratingField.icons.ratingIcon.width}
				height={theme.ratingField.icons.ratingIcon.height}
				viewBox="0 0 22 22"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				{filled ? (
					<path
						d="M21.69 8.27a2 2 0 00-1.61-1.36l-5-.73-2.29-4.57a2 2 0 00-3.59 0L7 6.17 2 6.9a2 2 0 00-1.11 3.41l3.64 3.55-.86 5a2 2 0 00.8 2A2 2 0 006.5 21l4.5-2.38L15.5 21a2 2 0 002.11-.15 2 2 0 00.8-2l-.86-5 3.64-3.55a2 2 0 00.5-2.03z"
						fill={theme.ratingField.icons.ratingIcon.fill}
					/>
				) : (
					<path
						d="M4.39 20.83a2 2 0 01-.8-2l.86-5-3.64-3.55a2 2 0 01-.51-2 2 2 0 011.62-1.36l5-.73 2.25-4.56a2 2 0 013.59 0L15 6.17l5 .73a2 2 0 011.62 1.36 2 2 0 01-.51 2l-3.64 3.55.86 5A2 2 0 0115.5 21L11 18.62 6.5 21a2 2 0 01-2.11-.17zm7.54-4l4.5 2.37-.86-5a2 2 0 01.57-1.77l3.64-3.55-5-.73a2 2 0 01-1.51-1.09L11 2.5 8.75 7.06a2 2 0 01-1.51 1.09l-5 .73 3.64 3.55a2 2 0 01.57 1.77l-.86 5 4.5-2.37a2 2 0 011.84.02v-.02z"
						fill={theme.ratingField.icons.ratingIcon.fill}
					/>
				)}
			</svg>
		</div>
	);
};

export const RatingIcon = memo(
	styled(Component)(
		({
			theme: {
				ratingField: {
					icons: { ratingIcon },
				},
			},
		}: {
			theme: Theme;
		}) => ratingIcon,
		styles
	)
);
